<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" class="row" mat-dialog-content>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-4 mb-2">
            <label for="">Id</label>
            <input class="form-control" formControlName="id" type="text">
          </div>
          <div class="col-lg-8">
            <label for="">Material</label>
            <div class="d-flex">
              <input autocomplete="off" class="form-control" formControlName="mat" name="mat" type="text">
              <button (click)="searchMaterial()" [disabled]="agregarForm.controls['mat'].errors"
                      class="btn btn-success ms-2">Buscar
              </button>
            </div>
            <div
              *ngIf="agregarForm.controls['mat'].invalid && (agregarForm.controls['mat'].dirty || agregarForm.controls['mat'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['mat'].errors">
                  El campo es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-12 mb-2">
            <label for="">Material Descripción</label>
            <input autocomplete="off" class="form-control" formControlName="materialDescripcion" name="desca"
                   type="text">

          </div>
          <div class="mb-2">
            <label for="">Factor de Conversión</label>
            <input class="form-control" formControlName="fact" type="number">
            <div
              *ngIf="agregarForm.controls['fact'].invalid && (agregarForm.controls['fact'].dirty || agregarForm.controls['fact'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="agregarForm.controls['fact'].errors">
                  El campo es requerido.
                </div>
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mb-2">
          <label for="">Descripción</label>
          <input class="form-control" formControlName="desca" type="text">
          <div
            *ngIf="agregarForm.controls['desca'].invalid && (agregarForm.controls['desca'].dirty || agregarForm.controls['desca'].touched)"
            class="text-danger">
            <small>
              <div *ngIf="agregarForm.controls['desca'].errors">
                El campo es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="mb-2">
          <label for="">API Corregido</label>
          <input class="form-control" formControlName="val" type="number">
          <div
            *ngIf="agregarForm.controls['val'].invalid && (agregarForm.controls['val'].dirty || agregarForm.controls['val'].touched)"
            class="text-danger">
            <small>
              <div *ngIf="agregarForm.controls['val'].errors">
                El campo es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="mb-2">
          <label for="">Unidad</label>
          <input class="form-control" formControlName="uni" type="text">
          <div
            *ngIf="agregarForm.controls['uni'].invalid && (agregarForm.controls['uni'].dirty || agregarForm.controls['uni'].touched)"
            class="text-danger">
            <small>
              <div *ngIf="agregarForm.controls['uni'].errors">
                El campo es requerido.
              </div>
            </small>
          </div>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
                                   [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
